export default {

  /**
   * Sends the contact request.
   *
   * @param  Vue instance
   */
  postNewsletter(vm) {

    vm.sendingForm = true;

    axios.post('/api/newsletter', vm.newsletter)
      .then((response) => {

        //sucesso
        if (response.data.status) {
          swal('OK', 'Cadastro realizado com sucesso!', 'success');
        } else {
          swal('Ooops...', 'Não foi possível realizar o cadastro.', 'error');
        }

        vm.sendingForm = false;

      })
      .catch(function (error) {

        if (error.response.status === 422) {

          let validationErrors = error.response.data.errors;

          let fields = Object.keys(validationErrors);

          let errors = [];

          fields.forEach((field) => {
            errors.push(validationErrors[field][0]);
          });

          swal('Ooops...', errors.join('\n'), 'error');

          vm.sendingForm = false;

        }

      });
  },

};
